// import { v4 as uuid } from "uuid";

import uuid from "react-uuid";

/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: uuid(),
    title: "The Fastest Way To Load JavaScript",
    thumbnail: "https://i3.ytimg.com/vi/BMuFBYw91UQ/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLQpvSjzSCSo8ZKCjBZS7TRX7omb_kyQirh2zgEY=s88-c-k-c0x00ffffff-no-rj",
    viewCount: "111k views",
    subscriber: "922k subscriber",
    videoLength: "10:20",
    creator: "Web Dev Simplified",
    categoryName: "Programming",
    youtubeId: "BMuFBYw91UQ&t=62s",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Difference between programming and coding",
    thumbnail: "https://i3.ytimg.com/vi/6tZz6gr1h9E/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLRKuH4PmoGusmEx6k2R6HJZaMggIA_cMt3lvO6t_Q=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "694k views",
    subscriber: "703k subscriber",
    videoLength: "6:58",
    creator: "Soham Shah",
    categoryName: "Programming",
    youtubeId: "6tZz6gr1h9E&t=2s",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },

  {
    _id: uuid(),
    title: "Awesome Video about Coding",
    thumbnail: "https://i3.ytimg.com/vi/Dv7gLpW91DM/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLTi_A2NzTsOiJthbojwCbdTdRI-dadeY-4QHTpf3A=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "530k views",
    subscriber: "1.73k subscriber",
    videoLength: "5:43",
    creator: "Soham Shah",
    categoryName: "Programming",
    youtubeId: "Dv7gLpW91DM",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Zero to Full-Time Programmer in 5 Steps",
    thumbnail: "https://i3.ytimg.com/vi/s9iPo9YMU70/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLR2mPVgBIubx0-LLBrUYUAz8cIXrIEOqStUiCxBig=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "998k views",
    subscriber: "165k subscriber",
    videoLength: "8:32",
    creator: "Kenny Gunderman",
    categoryName: "Programming",
    youtubeId: "s9iPo9YMU70",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Reason Why People Fail Learning To Code!",
    thumbnail: "https://i3.ytimg.com/vi/MiYFenzWruE/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLT3EnMXtIOvDT4CL7obl0-acSZCBhMuapXBQFksVQ=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "648k views",
    subscriber: "2.76M subscriber",
    videoLength: "4:45",
    creator: "CodeWithHarry",
    categoryName: "Programming",
    youtubeId: "eKqY-oP1d_Y&t",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Waxing - Stand Up Comedy",
    thumbnail: "https://i3.ytimg.com/vi/z12bz7adLKI/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLS7IEPwzVpf3MOKIBHsLlIIG_UTH7CKO2iKYNxw4A=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "39M views",
    subscriber: "3.56M subscriber",
    videoLength: "8:21",
    creator: "Anubhav Singh Bassi",
    categoryName: "Comedy",
    youtubeId: "z12bz7adLKI",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "PUBG With Pariwar | Harsh Beniwal",
    thumbnail: "https://i3.ytimg.com/vi/-vqo9V0qxLE/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLQ_r8ZRXW8qpx2F3WpUxBBnNP_u53_v0b5Fq9Qfmw=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "39M views",
    subscriber: "14.5M subscriber",
    videoLength: "22:01",
    creator: "Harsh Beniwal",
    categoryName: "Comedy",
    youtubeId: "-vqo9V0qxLE",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Nora क्यों नहीं है Petrol Pump में Allowed?",
    thumbnail: "https://i3.ytimg.com/vi/UCzb1bgLpsE/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLTRpFl9QM_NJEPXePeARLsgedgqXujizE0dqoEovA=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "2.7M views",
    subscriber: "132M subscriber",
    videoLength: "9:35",
    creator: "SET India",
    categoryName: "Comedy",
    youtubeId: "UCzb1bgLpsE",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Paan | Stand-up Comedy by Aakash Gupta",
    thumbnail: "https://i3.ytimg.com/vi/6d2wzfx4sRs/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLSvPEUzOL_qQkQQd17lcsvj3ikeb2iEj92MUBi91A=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "11M views",
    subscriber: "3.15M subscriber",
    videoLength: "10:00",
    creator: "Aakash Gupta",
    categoryName: "Comedy",
    youtubeId: "6d2wzfx4sRs",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Differences Between Var, Let, and Const",
    thumbnail: "https://i3.ytimg.com/vi/9WIJQDvt4Us/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLQpvSjzSCSo8ZKCjBZS7TRX7omb_kyQirh2zgEY=s88-c-k-c0x00ffffff-no-rj",
    viewCount: "80k views",
    subscriber: "922k subscriber",
    creator: "Web Dev Simplified",
    categoryName: "Programming",
    youtubeId: "9WIJQDvt4Us",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Kalandar | Munawar x Farhan Khan",
    thumbnail: "https://i3.ytimg.com/vi/7KxQ6ZaOZ0g/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLT4Em51isWMSdGWnXAjOQr-D2WRCnnbGQbRXjyj1JU=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "2.2M views",
    subscriber: "2.7M subscriber",
    videoLength: "4:20",
    creator: "Munawar Faruqui",
    categoryName: "Rap",
    youtubeId: "7KxQ6ZaOZ0g",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "LOSER Ft. Dino James | Being Indian",
    thumbnail: "https://i3.ytimg.com/vi/I63RkFdgjos/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ZaHgg2lD4pWwMNnYM9d-p5gVFEt22Tot5PatuS78sBMWsNRH6ZIg9YTDi9CIQsLhaC0HOLvNsg=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "72M views",
    subscriber: "2.98M subscriber",
    videoLength: "4:25",
    creator: "BeingIndia",
    categoryName: "Rap",
    youtubeId: "I63RkFdgjos",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Jawab | Munawar x Spectra | Prod by Shawie",
    thumbnail: "https://i3.ytimg.com/vi/ziFS1ATzuiY/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLT4Em51isWMSdGWnXAjOQr-D2WRCnnbGQbRXjyj1JU=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "2.3M views",
    subscriber: "2.7M subscriber",
    videoLength: "5:04",
    creator: "Munawar Faruqui",
    categoryName: "Rap",
    youtubeId: "ziFS1ATzuiY",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },

  {
    _id: uuid(),
    title: "Raftaar x Sonu Kakkar x Muhfaad - Sare Karo Dab",
    thumbnail: "https://i3.ytimg.com/vi/zIPTP3TKUSg/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/EEGERwlaKJd27zSEPQF3d__-tPyppIgFfKvNfBkWa7ssMKBWqQUbuCTLe-kAnTB1r6kJQVxyxwY=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "37M views",
    subscriber: "83.8M subscriber",
    videoLength: "3:56",
    creator: "Zee Music Company",
    categoryName: "Rap",
    youtubeId: "zIPTP3TKUSg",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "IT WILL GIVE YOU GOOSEBUMPS - Elon Musk",
    thumbnail: "https://i3.ytimg.com/vi/t1XCzWlYWeA/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/M_xZT_pxAppsRpIMP5ZC5BfRrQZW_1eBZYsEK0OGr_5jVp6lSj_1a3nawY-PHqwwDXHmt0vEo7g=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "8.7M views",
    subscriber: "140k subscriber",
    videoLength: "6:32",
    creator: "Mindset Mentor",
    categoryName: "Motivation",
    youtubeId: "t1XCzWlYWeA",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "NO EXCUSES - Best Motivational Video",
    thumbnail: "https://i3.ytimg.com/vi/wnHW6o8WMas/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLTh91QMR-uz2GOSCg8rbjglhsYKbFpFAJeC4dKZmg=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "56M views",
    subscriber: "2.24M subscriber",
    videoLength: "3:20",
    creator: "Ben Lionel Scott",
    categoryName: "Motivation",
    youtubeId: "wnHW6o8WMas",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Never Give Up Motivation Speech by Elon Musk",
    thumbnail: "https://i3.ytimg.com/vi/u6NlyoRoAzA/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/7B1_neBkMuFZKlyJc4NCEuzSF5vqrhhNNcDYPt71_zZlPnm0xd5LMUESXkLgiiEOTjtI9eTMkA=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "174k views",
    subscriber: "1.77k subscriber",
    videoLength: "2:45",
    creator: "Motivation Hunt",
    categoryName: "Motivation",
    youtubeId: "u6NlyoRoAzA",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Work Like Me, To Become The Best - Cristiano Ronaldo",
    thumbnail: "https://i3.ytimg.com/vi/iYoXFg5D4NU/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/ytc/AKedOLSCaeh5a6TiBZ4vEYYmwumbGpo4nltvRVP7um-QyQ=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "868k views",
    subscriber: "6.57k subscriber",
    videoLength: "3:14",
    creator: "EntreXpreneur",
    categoryName: "Motivation",
    youtubeId: "iYoXFg5D4NU",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Hustle | RCR Enters the Hustle | Raps",
    thumbnail: "https://i3.ytimg.com/vi/LdeDbk5V2ws/maxresdefault.jpg",
    channelImg:
      "https://yt3.ggpht.com/bo7jT1LvWF_QKP0FFr2u4CBsV59Sc1h330UfO7fFOyF_iD6xR0N02buRvZYZFud0ScxNbL0IUA=s48-c-k-c0x00ffffff-no-rj",
    viewCount: "12M views",
    subscriber: "4.76M subscriber",
    videoLength: "3:56",
    creator: "MTV India",
    categoryName: "Rap",
    youtubeId: "LdeDbk5V2ws",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
];
